import React from 'react'
import { Typography } from '@mui/material'
import { NoFilteredSessionsViewProps } from '../types'
import {
  WebinarRegistrationPrompt,
  getWebinarIdFromNickname,
  getRegistrationUrlFromNickname,
} from '../components'

const NoFilteredSessionsView: React.FC<NoFilteredSessionsViewProps> = ({
  selectedCategory,
  isCategoryAccessible,
  categoryInfo,
  webinarTypes,
  onRegistrationSuccess,
  sessions = [],
}) => {
  if (selectedCategory && isCategoryAccessible(selectedCategory)) {
    return (
      <WebinarRegistrationPrompt
        categoryName={selectedCategory}
        description={categoryInfo?.description}
        schedule={categoryInfo?.schedule}
        webinarId={getWebinarIdFromNickname(selectedCategory, webinarTypes)}
        registrationUrl={getRegistrationUrlFromNickname(selectedCategory, webinarTypes)}
        onRegistrationSuccess={onRegistrationSuccess}
      />
    )
  }

  return <Typography>No sessions found matching the selected filter.</Typography>
}

export default NoFilteredSessionsView
